import React from 'react'
const ChecoutItems = ({item}) => {
  return (
    <div className='checkout-item'>
        <img src={`/uploads/${item.image}`} alt="test" />
        <p>{item.item}</p>
        <p>{item.quantity}</p>
        <p>{item.price} Ft</p>
    </div>
  )
}

export default ChecoutItems